import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { PLAN_LIST_QUERY_NAME } from '@/modules/plan/PlansList/queries/usePlansList.query';

export default (planId: string) => {
  const queryClient = useQueryClient();
  const mutation = useMutation(() => api.delete(API_URL.PLANS_BY_PLAN_ID(planId)), {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [PLAN_LIST_QUERY_NAME],
      });
    },
  });
  return {
    handleDelete: mutation.mutate,
  };
};
